/**
 * WebFormsUtility hooks into the ASP.NET AJAX PageRequestManager to observe and react to partial (UpdatePanel) postbacks.
 */
export class WebFormsUtility {
    /**
     * The singleton ASP.NET AJAX PageRequestManager instance for the current page, used to observe partial postback lifecycle events.
     */
    public static get pageRequestManager() {
        return window.Sys.WebForms.PageRequestManager.getInstance();
    }

    private static requestsNameToCallback: { [key: string]: (sender: any, args: any) => void } = {};

    /**
     * Registers a callback to run when a partial postback begins, replacing any previously registered callback with the same name.
     * @param callback Invoked when the PageRequestManager's beginRequest event fires
     * @param name A key identifying this callback so it can later be removed via {@link removeRequest} (defaults to "genericBegin"); registering again with the same name replaces the previous callback
     */
    public static addBeginRequest(callback: (sender: Telerik.Web.UI.RadWindow, args: Sys.WebForms.BeginRequestEventArgs) => void, name: string = "genericBegin") {
        this.removeRequest("beginRequest", name);
        this.pageRequestManager.add_beginRequest(callback);
        this.requestsNameToCallback[name] = callback;
    }

    /**
     * Registers a callback to run when a partial postback ends, replacing any previously registered callback with the same name.
     * @param callback Invoked when the PageRequestManager's endRequest event fires
     * @param name A key identifying this callback so it can later be removed via {@link removeRequest} (defaults to "genericEnd"); registering again with the same name replaces the previous callback
     */
    public static addEndRequest(callback: (sender: Telerik.Web.UI.RadWindow, args: Sys.WebForms.EndRequestEventArgs) => void, name: string = "genericEnd") {
        this.removeRequest("endRequest", name);
        this.pageRequestManager.add_endRequest(callback);
        this.requestsNameToCallback[name] = callback;
    }

    /**
     * Unregisters a previously named beginRequest/endRequest callback from the PageRequestManager, if one is currently registered under that name.
     * @param requestType Which PageRequestManager event the callback was registered against, e.g. "beginRequest" or "endRequest"
     * @param name The key the callback was registered under
     */
    public static removeRequest(requestType: string, name: string) {
        let callback = this.requestsNameToCallback[name];
        if (callback != null) {
            this.pageRequestManager["remove_"+requestType](callback);
            this.requestsNameToCallback[name] = null;
        }
    }
}